import { FC, ReactNode } from 'react'
import { useVariant } from '@unleash/proxy-client-react'

import AppsVersionContext from 'components/contexts/AppsVersionContext'
import { branchNameSubfolder } from 'config/featureBranch'
import { UNLEASH_FEATURE_FLAGS } from 'utils/constants'

interface AppsVersionProviderProps {
  children?: ReactNode
}

const useGetTargetBuild = (unleashFeatureFlag: string) => {
  const targetVersion = useVariant(unleashFeatureFlag)?.payload?.value ?? 'latest'
  return branchNameSubfolder.length > 0 ? branchNameSubfolder : targetVersion
}

const AppsVersionProvider: FC<AppsVersionProviderProps> = ({ children }) => {
  const contactsTargetBuild = useGetTargetBuild(UNLEASH_FEATURE_FLAGS.contactsVersion)
  const contactCenterTargetBuild = useGetTargetBuild(UNLEASH_FEATURE_FLAGS.ccConfigurationVersion)

  return (
    <AppsVersionContext.Provider value={{ contactsTargetBuild, contactCenterTargetBuild }}>
      {children}
    </AppsVersionContext.Provider>
  )
}

export default AppsVersionProvider
